/* ===== game/isle-tiles.ts — 섬을 든 것의 섬 — 하늘 섬과 같은 타일(하늘 풀 · 구름 · 하늘 돌 · 하늘 나무)로 굽는다 ===== */
import { T } from '../data.js';
import { TS } from '../world.js';
import { TileArt } from '../tileart.js';
/* ★ 섬을 손그림 조각(역삼각 판 · 갈색 다각형)으로 그렸더니 세계의 하늘 섬과 달라 '저퀄 이상한 섬'으로 보였다(점검판 2026-11-02).
   world/sky.ts carveIsland 와 같은 층(맨 윗줄 하늘 풀 · 구름 · 아래 하늘 돌 · 에테르 맥)을 타일 그림 그대로 캔버스에 한 번 굽고 다시 쓴다. */

type Isle = { cv: HTMLCanvasElement; top: number };
const cache = new Map<string, Isle>();
const hash = (a: number, b: number) => { const h = Math.sin(a * 127.1 + b * 311.7) * 43758.5453; return h - Math.floor(h); };

/** cols 칸 너비의 섬 — top 은 캔버스 안에서 풀 윗면의 y(px) · tree 면 하늘 나무 하나 · broken 이면 가장자리가 떨어져 나간다 */
export function isleCanvas(cols: number, seed: number, tree: boolean, broken: boolean): Isle | null {
  if (!TileArt.atlas || typeof document === 'undefined') return null;
  const key = cols + '|' + seed + '|' + tree + '|' + broken;
  const hit = cache.get(key); if (hit) return hit;
  const up = tree ? 6 : 1, rows = up + Math.ceil(cols * 0.26) + 4;
  const cv = document.createElement('canvas'); cv.width = cols * TS; cv.height = rows * TS;
  const c = cv.getContext('2d')!; c.imageSmoothingEnabled = false;
  const rw = cols / 2, rh = Math.max(3, Math.round(cols * 0.26)), cl = tree ? 1 : 0;            // 하늘 섬 비율(폭 26~52 · 깊이 4~8)
  const put = (x: number, y: number, id: number) => TileArt.draw(c, id, (hash(x + seed, y) * TileArt.V) | 0, x * TS, (y + up) * TS);
  for (let x = 0; x < cols; x++) {
    const t = (x + 0.5 - rw) / rw;
    let depth = Math.round(rh * Math.sqrt(Math.max(0, 1 - t * t)) * (0.85 + hash(x, seed) * 0.3));
    if (broken && (x === 0 || x === cols - 1 || hash(x, seed + 3) < 0.12)) depth = Math.max(1, depth - 2);
    if (depth < 2) depth = 2;
    for (let y = 0; y < depth; y++) put(x, y, y === 0 ? T.SKYGRASS : y <= cl ? T.CLOUD : T.SKYSTONE);   // 구름은 한 줄만(두 줄이면 등에 하얀 판을 얹은 것 같았다) · 던지는 덩이는 구름 없이
    if (depth > 3 && hash(x, seed + 1) < 0.2) put(x, depth - 1, T.AETHER);
  }
  if (tree) {                                                       // 하늘 나무 — 줄기 넷 · 잎 덩이
    const tx = Math.max(1, Math.min(cols - 2, Math.round(cols * 0.28)));
    for (let y = 1; y <= 4; y++) put(tx, -y, T.WOOD);
    for (let dy = -6; dy <= -4; dy++) for (let dx = -2; dx <= 2; dx++) if (Math.abs(dx) + Math.abs(dy + 5) < 4) put(tx + dx, dy, T.SKYLEAF);
  }
  const out = { cv, top: up * TS };
  cache.set(key, out);
  return out;
}
